import AuthButton from "./AuthButton";
import { APPLICATION_NAME } from "../../util/constants";
import InternalLink from "./Link";
import AppBar from "./AppBar";
import Toolbar from "./Toolbar";
import FavoritesDropdown from "./FavoritesDropdown";
import { mergeSxStyles } from "../../styles/util";
import { useGetPreferencesQuery } from "../../services/graphql/api";
import { selectPermittedToFavorite } from "../../services/authorization/slices";
import { useSelector } from "react-redux";

const AppLink = ({ sx, ...props }) => (
  <InternalLink to="/" disableHighlightCurrent {...props} sx={mergeSxStyles(sx, (theme) => theme.typography.h4)}>
    {APPLICATION_NAME}
  </InternalLink>
);

const sizingStyles = () => {
  return {
    minHeight: "44px"
  };
};

export default function Navbar() {
  const canFavoriteThings = useSelector(selectPermittedToFavorite);
  useGetPreferencesQuery(undefined, { skip: !canFavoriteThings });

  return (
    <AppBar>
      <Toolbar>
        <AppLink />
        {canFavoriteThings && <FavoritesDropdown className="margin-left-auto margin-right-3" />}
        <AuthButton 
          className={!canFavoriteThings ? 'margin-left-auto' : undefined} 
          sx={sizingStyles} />
      </Toolbar>
    </AppBar>
  );
}
